import { horizontalGap, tk } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'
import { CardSkeleton, LabelSkeleton, UserReviewLoading } from '../UserReview/UserReviewLoading'

const Wrapper = styled.div`
  overflow: hidden;
`

const Content = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${tk('spacing_2xs')}; // needed to show the shadow of the items

  ${horizontalGap('spacing_md')}

  ${CardSkeleton} {
    min-width: 350px;
    box-shadow: ${tk('shadow_md_bottom')};
    @media ${tk('mq_desktop_md')} {
      min-width: unset;
    }
  }
  ${LabelSkeleton} {
    width: 60px;
  }
`

interface ListLoadingProps {
  amount?: number
}

export function ListLoading({ amount = 10 }: ListLoadingProps) {
  const reviewLoadings = []
  for (let i = 0; i < amount; i++) {
    reviewLoadings.push(<UserReviewLoading key={i} />)
  }

  return (
    <Wrapper>
      <Content>{reviewLoadings}</Content>
    </Wrapper>
  )
}
